export default __webpack_public_path__ + "2961b3be527f9967e984b81fc41d290e.png";